/**
 * @fileoverview gRPC-Web generated client stub for social.voip
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: services/voip/voip.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var services_account_account_pb = require('../../services/account/account_pb.js')

var services_common_common_pb = require('../../services/common/common_pb.js')
const proto = {};
proto.social = {};
proto.social.voip = require('./voip_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.voip.VoipServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.social.voip.VoipServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.common.Pong>}
 */
const methodDescriptor_VoipService_Ping = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/Ping',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  services_common_common_pb.Pong,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Pong.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Pong)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Pong>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.ping =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/Ping',
      request,
      metadata || {},
      methodDescriptor_VoipService_Ping,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Pong>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.ping =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/Ping',
      request,
      metadata || {},
      methodDescriptor_VoipService_Ping);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.voip.SupportQueueResponse>}
 */
const methodDescriptor_VoipService_SupportConnectToQueueV2Stream = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/SupportConnectToQueueV2Stream',
  grpc.web.MethodType.SERVER_STREAMING,
  services_common_common_pb.Empty,
  proto.social.voip.SupportQueueResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.SupportQueueResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.SupportQueueResponse>}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.supportConnectToQueueV2Stream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/social.voip.VoipService/SupportConnectToQueueV2Stream',
      request,
      metadata || {},
      methodDescriptor_VoipService_SupportConnectToQueueV2Stream);
};


/**
 * @param {!proto.social.common.Empty} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.SupportQueueResponse>}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServicePromiseClient.prototype.supportConnectToQueueV2Stream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/social.voip.VoipService/SupportConnectToQueueV2Stream',
      request,
      metadata || {},
      methodDescriptor_VoipService_SupportConnectToQueueV2Stream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QueueData,
 *   !proto.social.voip.UserInQueue>}
 */
const methodDescriptor_VoipService_UserConnectToQueueV2Stream = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/UserConnectToQueueV2Stream',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.social.voip.QueueData,
  proto.social.voip.UserInQueue,
  /**
   * @param {!proto.social.voip.QueueData} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.UserInQueue.deserializeBinary
);


/**
 * @param {!proto.social.voip.QueueData} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.UserInQueue>}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.userConnectToQueueV2Stream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/social.voip.VoipService/UserConnectToQueueV2Stream',
      request,
      metadata || {},
      methodDescriptor_VoipService_UserConnectToQueueV2Stream);
};


/**
 * @param {!proto.social.voip.QueueData} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.UserInQueue>}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServicePromiseClient.prototype.userConnectToQueueV2Stream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/social.voip.VoipService/UserConnectToQueueV2Stream',
      request,
      metadata || {},
      methodDescriptor_VoipService_UserConnectToQueueV2Stream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.account.Account,
 *   !proto.social.voip.QueueData>}
 */
const methodDescriptor_VoipService_ConnectToUserV2 = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/ConnectToUserV2',
  grpc.web.MethodType.UNARY,
  services_account_account_pb.Account,
  proto.social.voip.QueueData,
  /**
   * @param {!proto.social.account.Account} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.QueueData.deserializeBinary
);


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.QueueData)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.QueueData>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.connectToUserV2 =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/ConnectToUserV2',
      request,
      metadata || {},
      methodDescriptor_VoipService_ConnectToUserV2,
      callback);
};


/**
 * @param {!proto.social.account.Account} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.QueueData>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.connectToUserV2 =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/ConnectToUserV2',
      request,
      metadata || {},
      methodDescriptor_VoipService_ConnectToUserV2);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.SupportQueueRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_SetSupportStatus = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/SetSupportStatus',
  grpc.web.MethodType.UNARY,
  proto.social.voip.SupportQueueRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.SupportQueueRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.SupportQueueRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.setSupportStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/SetSupportStatus',
      request,
      metadata || {},
      methodDescriptor_VoipService_SetSupportStatus,
      callback);
};


/**
 * @param {!proto.social.voip.SupportQueueRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.setSupportStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/SetSupportStatus',
      request,
      metadata || {},
      methodDescriptor_VoipService_SetSupportStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.FinishSupportRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_FinishSupport = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/FinishSupport',
  grpc.web.MethodType.UNARY,
  proto.social.voip.FinishSupportRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.FinishSupportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.FinishSupportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.finishSupport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/FinishSupport',
      request,
      metadata || {},
      methodDescriptor_VoipService_FinishSupport,
      callback);
};


/**
 * @param {!proto.social.voip.FinishSupportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.finishSupport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/FinishSupport',
      request,
      metadata || {},
      methodDescriptor_VoipService_FinishSupport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.SubmitFeedbackRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_SubmitFeedback = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/SubmitFeedback',
  grpc.web.MethodType.UNARY,
  proto.social.voip.SubmitFeedbackRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.SubmitFeedbackRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.SubmitFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.submitFeedback =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/SubmitFeedback',
      request,
      metadata || {},
      methodDescriptor_VoipService_SubmitFeedback,
      callback);
};


/**
 * @param {!proto.social.voip.SubmitFeedbackRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.submitFeedback =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/SubmitFeedback',
      request,
      metadata || {},
      methodDescriptor_VoipService_SubmitFeedback);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.VoipLog,
 *   !proto.social.voip.VoipLog>}
 */
const methodDescriptor_VoipService_GetUserQueueStatus = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/GetUserQueueStatus',
  grpc.web.MethodType.UNARY,
  proto.social.voip.VoipLog,
  proto.social.voip.VoipLog,
  /**
   * @param {!proto.social.voip.VoipLog} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.VoipLog.deserializeBinary
);


/**
 * @param {!proto.social.voip.VoipLog} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.VoipLog)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.VoipLog>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.getUserQueueStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/GetUserQueueStatus',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetUserQueueStatus,
      callback);
};


/**
 * @param {!proto.social.voip.VoipLog} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.VoipLog>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.getUserQueueStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/GetUserQueueStatus',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetUserQueueStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.FAQ,
 *   !proto.social.voip.FAQ>}
 */
const methodDescriptor_VoipService_GetFAQById = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/GetFAQById',
  grpc.web.MethodType.UNARY,
  proto.social.voip.FAQ,
  proto.social.voip.FAQ,
  /**
   * @param {!proto.social.voip.FAQ} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.FAQ.deserializeBinary
);


/**
 * @param {!proto.social.voip.FAQ} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.FAQ)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.FAQ>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.getFAQById =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/GetFAQById',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetFAQById,
      callback);
};


/**
 * @param {!proto.social.voip.FAQ} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.FAQ>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.getFAQById =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/GetFAQById',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetFAQById);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Pagination,
 *   !proto.social.voip.FAQListResponse>}
 */
const methodDescriptor_VoipService_GetFAQList = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/GetFAQList',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Pagination,
  proto.social.voip.FAQListResponse,
  /**
   * @param {!proto.social.common.Pagination} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.FAQListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.FAQListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.FAQListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.getFAQList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/GetFAQList',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetFAQList,
      callback);
};


/**
 * @param {!proto.social.common.Pagination} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.FAQListResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.getFAQList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/GetFAQList',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetFAQList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.FAQ,
 *   !proto.social.voip.FAQListResponse>}
 */
const methodDescriptor_VoipService_GetFAQByParentId = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/GetFAQByParentId',
  grpc.web.MethodType.UNARY,
  proto.social.voip.FAQ,
  proto.social.voip.FAQListResponse,
  /**
   * @param {!proto.social.voip.FAQ} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.FAQListResponse.deserializeBinary
);


/**
 * @param {!proto.social.voip.FAQ} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.FAQListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.FAQListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.getFAQByParentId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/GetFAQByParentId',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetFAQByParentId,
      callback);
};


/**
 * @param {!proto.social.voip.FAQ} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.FAQListResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.getFAQByParentId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/GetFAQByParentId',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetFAQByParentId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.voip.QuickAccessListResponse>}
 */
const methodDescriptor_VoipService_GetQuickAccessByFilter = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/GetQuickAccessByFilter',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.voip.QuickAccessListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.QuickAccessListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.QuickAccessListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.QuickAccessListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.getQuickAccessByFilter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/GetQuickAccessByFilter',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetQuickAccessByFilter,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.QuickAccessListResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.getQuickAccessByFilter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/GetQuickAccessByFilter',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetQuickAccessByFilter);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.AdminVoipOperatorReportRequest,
 *   !proto.social.voip.AdminVoipOperatorReportResponse>}
 */
const methodDescriptor_VoipService_AdminGetSupportReport = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminGetSupportReport',
  grpc.web.MethodType.UNARY,
  proto.social.voip.AdminVoipOperatorReportRequest,
  proto.social.voip.AdminVoipOperatorReportResponse,
  /**
   * @param {!proto.social.voip.AdminVoipOperatorReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.AdminVoipOperatorReportResponse.deserializeBinary
);


/**
 * @param {!proto.social.voip.AdminVoipOperatorReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.AdminVoipOperatorReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.AdminVoipOperatorReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminGetSupportReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetSupportReport',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetSupportReport,
      callback);
};


/**
 * @param {!proto.social.voip.AdminVoipOperatorReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.AdminVoipOperatorReportResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminGetSupportReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetSupportReport',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetSupportReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.AdminFAQ,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_AdminUpsertFAQ = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminUpsertFAQ',
  grpc.web.MethodType.UNARY,
  proto.social.voip.AdminFAQ,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.AdminFAQ} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.AdminFAQ} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminUpsertFAQ =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminUpsertFAQ',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminUpsertFAQ,
      callback);
};


/**
 * @param {!proto.social.voip.AdminFAQ} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminUpsertFAQ =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminUpsertFAQ',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminUpsertFAQ);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.AdminFAQ,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_AdminDeleteFAQ = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminDeleteFAQ',
  grpc.web.MethodType.UNARY,
  proto.social.voip.AdminFAQ,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.AdminFAQ} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.AdminFAQ} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminDeleteFAQ =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminDeleteFAQ',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminDeleteFAQ,
      callback);
};


/**
 * @param {!proto.social.voip.AdminFAQ} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminDeleteFAQ =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminDeleteFAQ',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminDeleteFAQ);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QuickAccess,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_AdminUpsertQuickAccess = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminUpsertQuickAccess',
  grpc.web.MethodType.UNARY,
  proto.social.voip.QuickAccess,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.QuickAccess} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.QuickAccess} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminUpsertQuickAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminUpsertQuickAccess',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminUpsertQuickAccess,
      callback);
};


/**
 * @param {!proto.social.voip.QuickAccess} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminUpsertQuickAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminUpsertQuickAccess',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminUpsertQuickAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QuickAccess,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_AdminDeleteQuickAccess = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminDeleteQuickAccess',
  grpc.web.MethodType.UNARY,
  proto.social.voip.QuickAccess,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.QuickAccess} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.QuickAccess} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminDeleteQuickAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminDeleteQuickAccess',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminDeleteQuickAccess,
      callback);
};


/**
 * @param {!proto.social.voip.QuickAccess} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminDeleteQuickAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminDeleteQuickAccess',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminDeleteQuickAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.Empty,
 *   !proto.social.voip.AdminFAQListResponse>}
 */
const methodDescriptor_VoipService_AdminGetAllFAQ = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminGetAllFAQ',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.Empty,
  proto.social.voip.AdminFAQListResponse,
  /**
   * @param {!proto.social.common.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.AdminFAQListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.AdminFAQListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.AdminFAQListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminGetAllFAQ =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetAllFAQ',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetAllFAQ,
      callback);
};


/**
 * @param {!proto.social.common.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.AdminFAQListResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminGetAllFAQ =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetAllFAQ',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetAllFAQ);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.AdminGetSupportReportRequest,
 *   !proto.social.voip.AdminGetSupportReportResponse>}
 */
const methodDescriptor_VoipService_AdminGetSupportsDetailedReport = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminGetSupportsDetailedReport',
  grpc.web.MethodType.UNARY,
  proto.social.voip.AdminGetSupportReportRequest,
  proto.social.voip.AdminGetSupportReportResponse,
  /**
   * @param {!proto.social.voip.AdminGetSupportReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.AdminGetSupportReportResponse.deserializeBinary
);


/**
 * @param {!proto.social.voip.AdminGetSupportReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.AdminGetSupportReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.AdminGetSupportReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminGetSupportsDetailedReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetSupportsDetailedReport',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetSupportsDetailedReport,
      callback);
};


/**
 * @param {!proto.social.voip.AdminGetSupportReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.AdminGetSupportReportResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminGetSupportsDetailedReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetSupportsDetailedReport',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetSupportsDetailedReport);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.VoipLogRequest,
 *   !proto.social.voip.VoipLogResponse>}
 */
const methodDescriptor_VoipService_AdminGetVoipLogs = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminGetVoipLogs',
  grpc.web.MethodType.UNARY,
  proto.social.voip.VoipLogRequest,
  proto.social.voip.VoipLogResponse,
  /**
   * @param {!proto.social.voip.VoipLogRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.VoipLogResponse.deserializeBinary
);


/**
 * @param {!proto.social.voip.VoipLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.VoipLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.VoipLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminGetVoipLogs =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetVoipLogs',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetVoipLogs,
      callback);
};


/**
 * @param {!proto.social.voip.VoipLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.VoipLogResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminGetVoipLogs =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetVoipLogs',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetVoipLogs);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.voip.QuickAnswerListResponse>}
 */
const methodDescriptor_VoipService_GetQuickAnswers = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/GetQuickAnswers',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.voip.QuickAnswerListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.QuickAnswerListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.QuickAnswerListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.QuickAnswerListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.getQuickAnswers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/GetQuickAnswers',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetQuickAnswers,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.QuickAnswerListResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.getQuickAnswers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/GetQuickAnswers',
      request,
      metadata || {},
      methodDescriptor_VoipService_GetQuickAnswers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.common.FindRequest,
 *   !proto.social.voip.QuickAnswerListResponse>}
 */
const methodDescriptor_VoipService_AdminGetQuickAnswers = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminGetQuickAnswers',
  grpc.web.MethodType.UNARY,
  services_common_common_pb.FindRequest,
  proto.social.voip.QuickAnswerListResponse,
  /**
   * @param {!proto.social.common.FindRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.social.voip.QuickAnswerListResponse.deserializeBinary
);


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.voip.QuickAnswerListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.voip.QuickAnswerListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminGetQuickAnswers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetQuickAnswers',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetQuickAnswers,
      callback);
};


/**
 * @param {!proto.social.common.FindRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.voip.QuickAnswerListResponse>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminGetQuickAnswers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminGetQuickAnswers',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminGetQuickAnswers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QuickAnswer,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_UpsertQuickAnswer = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/UpsertQuickAnswer',
  grpc.web.MethodType.UNARY,
  proto.social.voip.QuickAnswer,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.QuickAnswer} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.upsertQuickAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/UpsertQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_UpsertQuickAnswer,
      callback);
};


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.upsertQuickAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/UpsertQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_UpsertQuickAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QuickAnswer,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_DeleteQuickAnswer = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/DeleteQuickAnswer',
  grpc.web.MethodType.UNARY,
  proto.social.voip.QuickAnswer,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.QuickAnswer} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.deleteQuickAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/DeleteQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_DeleteQuickAnswer,
      callback);
};


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.deleteQuickAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/DeleteQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_DeleteQuickAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QuickAnswer,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_AdminUpsertQuickAnswer = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminUpsertQuickAnswer',
  grpc.web.MethodType.UNARY,
  proto.social.voip.QuickAnswer,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.QuickAnswer} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminUpsertQuickAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminUpsertQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminUpsertQuickAnswer,
      callback);
};


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminUpsertQuickAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminUpsertQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminUpsertQuickAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.QuickAnswer,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_AdminDeleteQuickAnswer = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/AdminDeleteQuickAnswer',
  grpc.web.MethodType.UNARY,
  proto.social.voip.QuickAnswer,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.QuickAnswer} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.adminDeleteQuickAnswer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/AdminDeleteQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminDeleteQuickAnswer,
      callback);
};


/**
 * @param {!proto.social.voip.QuickAnswer} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.adminDeleteQuickAnswer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/AdminDeleteQuickAnswer',
      request,
      metadata || {},
      methodDescriptor_VoipService_AdminDeleteQuickAnswer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.social.voip.VoipCallRequest,
 *   !proto.social.common.Empty>}
 */
const methodDescriptor_VoipService_StartCall = new grpc.web.MethodDescriptor(
  '/social.voip.VoipService/StartCall',
  grpc.web.MethodType.UNARY,
  proto.social.voip.VoipCallRequest,
  services_common_common_pb.Empty,
  /**
   * @param {!proto.social.voip.VoipCallRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  services_common_common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.social.voip.VoipCallRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.social.common.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.social.common.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.social.voip.VoipServiceClient.prototype.startCall =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/social.voip.VoipService/StartCall',
      request,
      metadata || {},
      methodDescriptor_VoipService_StartCall,
      callback);
};


/**
 * @param {!proto.social.voip.VoipCallRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.social.common.Empty>}
 *     Promise that resolves to the response
 */
proto.social.voip.VoipServicePromiseClient.prototype.startCall =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/social.voip.VoipService/StartCall',
      request,
      metadata || {},
      methodDescriptor_VoipService_StartCall);
};


module.exports = proto.social.voip;

